module.exports = __webpack_public_path__ + "img/bx-partainer-timetable.365b5919.svg";